import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Table,
    Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as clientAction from "../../../store/bW9udGhXaXNlUGVu/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import MonthWiseTableComponent from "./MonthWiseTableComponent"
import { MultiSelect } from "react-multi-select-component"

const MonthWisePendingClientCount = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Month Wise Pending Client Count"

    //Fetching API
    useEffect(() => {
        dispatch(clientAction.loadProductStatus())
        dispatch(clientAction.loadRecordsMetaData())
    }, [])
    //Date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []
    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    //date format
    const update = useSelector(
        (specificstate) => specificstate.monthWisePendingClientCount
    )
    //product_data
    const { recordsMetaData = {}, product_data = [] } = update

    //Handle Change
    const [productStatusData, setProductStatusData] = useState({
        eventFromDate: "",
        eventToDate: "",
    })

    const handleChange = (e) => {
        setProductStatusData({
            ...productStatusData,
            [e.target.name]: e.target.value,
        })
    }

    const productCategoryOptions =
        !isEmpty(recordsMetaData) &&
            !isEmpty(recordsMetaData.productCategoryOptions)
            ? recordsMetaData.productCategoryOptions
            : []
    const [productCategory, setProductCategory] = useState([])


    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value

    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)


    const products = !isEmpty(productCategory)
        ? productCategory.map((m) => m.value)
        : ""
    const handleFilter = (e) => {
        e.preventDefault()

        var searchEmployee = !isEmpty(products) && products ? products : ""
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.productCategoryId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }

        dispatch(clientAction.loadProductStatus(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)
    }

    //reset

    const resetForm = () => {
        setProductCategory([])
        setSearchInput("")
        setProductStatusData({
            ...productStatusData,
            eventFromDate: "",
            eventToDate: "",
        })
        dispatch(clientAction.loadProductStatus())
    }

    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(
            clientAction.loadProductStatus({
                searchFilter: searchInput,
            })
        )
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }
    const exportToCsv = () => {
        var searchEmployee = !isEmpty(products) && products ? products : ""
        var searchFromDate =
            productStatusData && productStatusData.eventFromDate
                ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            productStatusData && productStatusData.eventToDate
                ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.productCategoryId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.eventFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.eventToDate = searchToDate
        }

        setDownloadLoading(true)

        api
            .post(`/get_eventMonth_wise_processStatus_new`, searchvalue)
            .then((response) => {
                const photoExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {
                        const deliverableData = data.deliverableData

                        const pendingLeads = !isEmpty(deliverableData)
                            ? deliverableData.pendingLeads
                            : 0
                        const pendingUniqueClients = !isEmpty(deliverableData)
                            ? deliverableData.pendingUniqueClients
                            : 0
                        const deliverableOne = !isEmpty(deliverableData)
                            ? deliverableData.deliverable_one
                            : 0
                       const deliverableZero =!isEmpty(deliverableData)
                       ? deliverableData.zero_deliverables
                            : []
                        const deliverableSecond = !isEmpty(deliverableData)
                            ? deliverableData.deliverable_second
                            : 0
                        const deliverableThree = !isEmpty(deliverableData)
                            ? deliverableData.deliverable_three
                            : 0
                        const deliverableGreaterThanThree = !isEmpty(
                            deliverableData
                        )
                            ? deliverableData.deliverable_greaterthenthree
                            : 0
                        const completedClients = !isEmpty(deliverableData)
                            ? deliverableData.completedClients
                            : 0
                        const dormantClients = !isEmpty(deliverableData)
                        ? deliverableData.dormantClients
                        : 0
                        const rowArray = [pendingLeads, pendingUniqueClients, deliverableZero, deliverableOne, deliverableSecond, deliverableThree, deliverableGreaterThanThree, completedClients,dormantClients]
                        const columnWiseTotal = rowArray.reduce((acc, val) => {
                            const accValue = !isNaN(acc) ? acc : 0
                            const itemValue = !isNaN(val) ? val : 0
                            const data = parseInt(accValue + itemValue)
                            return data
                        }, 0)
                        return {
                            _id: index,
                            pendingLeads,
                            pendingUniqueClients,
                            deliverableZero,
                            deliverableOne,
                            deliverableSecond,
                            deliverableThree,
                            deliverableGreaterThanThree,
                            completedClients,
                            dormantClients,
                            columnWiseTotal
                        }
                    })
                    : []

                const headerData = [
                    "",
                    ...product_data.map(
                        (value) => `${value.month} - ${value.year}`
                    ),
                ]

                // const subHeaderData = [
                //     "Client",
                //     ...product_data.map(() => "Count"),
                // ]

                const staticValues = [
                    "Pending Leads",
                    "Pending Unique Clients",
                    "Zero Deliverable",
                    "Deliverable One",
                    "Deliverable Second",
                    "Deliverable Three",
                    "Deliverable Greater Than Three",
                    "Completed Clients",
                    "Dormant Clients",
                    "Total"
                ]

                // Generate CSV data
                let usersCsv =
                    !isEmpty(photoExportDataTable) &&
                    photoExportDataTable.reduce((acc, user) => {
                        const {
                            pendingLeads,
                            pendingUniqueClients,
                            deliverableZero,
                            deliverableOne,
                            deliverableSecond,
                            deliverableThree,
                            deliverableGreaterThanThree,
                            completedClients,
                            dormantClients,
                            columnWiseTotal
                        } = user
                        acc.push([
                            // Empty cell for the "Client" column
                            pendingLeads,
                            pendingUniqueClients,
                            deliverableZero,
                            deliverableOne,
                            deliverableSecond,
                            deliverableThree,
                            deliverableGreaterThanThree,
                            completedClients,
                            dormantClients,
                            columnWiseTotal
                        ])

                        return acc
                    }, [])

                const transposedUsersCsv = staticValues.map((_, index) => [
                    staticValues[index],
                    ...usersCsv.map((row) => row[index]),
                ])



                const csvData = [
                    headerData.join(","),
                    // subHeaderData.join(","),
                    ...transposedUsersCsv.map((row) => row.join(","))
                    // Append the total row to the CSV data
                ].join("\n")

                downloadFile({
                    data: csvData,
                    fileName: "MonthWisePendingClientCount.csv",
                    fileType: "text/csv",
                })
                setDownloadLoading(false)
                return response.data
            })
            .catch((error) => {
                Promise.reject(error)
                setDownloadLoading(false)
            })
    }


    //table count value integration
    const deliverableData = !isEmpty(product_data) && product_data.length > 0
        ? product_data.map((data) => data.deliverableData)
        : []

    const pendingLeads = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.pendingLeads || 0)
        : []

    const pendingUniqueClients = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.pendingUniqueClients || 0)
        : []

    const deliverableOne = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.deliverable_one || 0)
        : []
    const deliverableZero = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.zero_deliverables || 0)
        : []

    const deliverableSecond = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.deliverable_second || 0)
        : []

    const deliverableThree = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.deliverable_three || 0)
        : []

    const deliverableGreaterThanThree = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.deliverable_greaterthenthree || 0)
        : []

    const completedClients = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.completedClients || 0)
        : []
        const dormantClients = deliverableData && deliverableData.length > 0
        ? deliverableData.map((data) => data?.dormantClients || 0)
        : []

//

    //total functionality 


    const columnWiseTotal = !isEmpty(deliverableData) && deliverableData.length > 0 ?
        (deliverableData.map(obj => {
            let total = 0
            for (const key in obj) {
                if (Object.hasOwnProperty.call(obj, key)) {
                    total += obj[key]
                }
            }
            return total
        })) : []

    //tab functionality

    const handleClickTab = (payload) => {
        const mode = payload.menuMode
        const statusDetails = {
            month: payload.month,
            year: payload.year,
            menuMode: payload.menuMode
        }

        // Use a callback function with setStatusData to ensure statusData is updated

        ///get_CrmWorker_detailed_processStatus_monthwise_details
        api
            .post(`/get_eventMonth_wise_details_list_processStatus_new`, statusDetails)
            .then((response) => {
                const statusData = !isEmpty(response.data.data) ? response.data.data : []
                setTimeout(() => {
                    // Use the current value of statusData, which should be updated due to the useEffect

                    const newTab = window.open("", "_blank", "width=600,height=400")
                    if (newTab) {
                        const container = newTab.document.createElement("div")
                            const fallbackDateFormat = "dd/mm/yyyy"
                        newTab.document.body.appendChild(container)
                        ReactDOM.render(
                            < MonthWiseTableComponent
                                data={statusData} // Use statusData directly here
                                dispatch={dispatch}
                                statusPayload={statusDetails}
                                name={payload.name}
                                dateFormat={dateFormat || fallbackDateFormat}
                                mode={mode}
                            />,
                            container
                        )
                        newTab.document.title = "MONTH-WISE-PENDING-CLIENT-COUNT"
                    }
                }, 2000)
            })
            .catch((error) => {
                Promise.reject(error)
                const newTab = window.open("", "_blank", "width=600,height=400")
                if (newTab) {
                    const container = newTab.document.createElement("div")
                    newTab.document.body.appendChild(container)
                    ReactDOM.render(
                        < MonthWiseTableComponent
                            data={[]} // Use statusData directly here
                            dispatch={dispatch}
                            statusPayload={statusDetails}
                            name={payload.name}
                            dateFormat={dateFormat}
                        />,
                        container
                    )
                    newTab.document.title = "MONTH-WISE-PENDING-CLIENT-COUNT"
                }
            })
    }

    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Product Category"}
                                                >
                                                    {"Product Category"}
                                                </Label>
                                            </div>

                                            <MultiSelect
                                                options={productCategoryOptions}
                                                value={productCategory}
                                                onChange={setProductCategory}
                                                labelledBy="Select"
                                                hasSelectAll={true}
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label className={"form-label"} htmlFor={"Event Date"}>
                                                    {"Event From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventFromDate"
                                                value={productStatusData.eventFromDate}
                                                max={productStatusData.eventToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Event To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="eventToDate"
                                                value={productStatusData.eventToDate}
                                                min={productStatusData.eventFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col
                                        md="8"
                                        lg="8"
                                        sm="12"
                                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                                    >
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">

                                    <Table responsive bordered>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                {!isEmpty(product_data) && product_data.length > 0
                                                    ? product_data.map((value, ix) => (
                                                        <th
                                                            style={{
                                                                minWidth: "230px",
                                                                textAlign: "center"
                                                            }}
                                                            key={ix}
                                                        >
                                                            {`${value.month} - ${value.year}`}
                                                        </th>
                                                    ))
                                                    : null}
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>Pending Leads</th>
                                                {!isEmpty(pendingLeads) && pendingLeads.length > 0
                                                    ? pendingLeads.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 1,
                                                            name: "Pending Leads"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)} style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Pending Unique Clients</th>
                                                {!isEmpty(pendingUniqueClients) && pendingUniqueClients.length > 0
                                                    ? pendingUniqueClients.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 2,
                                                            name: "Pending Unique Clients"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Zero Deliverable</th>
                                                {!isEmpty(deliverableZero) && deliverableZero.length > 0
                                                    ? deliverableZero.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 3,
                                                            name: "Zero Deliverable"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Deliverable One</th>
                                                {!isEmpty(deliverableOne) && deliverableOne.length > 0
                                                    ? deliverableOne.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 4,
                                                            name: "Deliverable One"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Second</th>
                                                {!isEmpty(deliverableSecond) && deliverableSecond.length > 0
                                                    ? deliverableSecond.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 5,
                                                            name: "Deliverable Second"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Three</th>
                                                {!isEmpty(deliverableThree) && deliverableThree.length > 0
                                                    ? deliverableThree.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 6,
                                                            name: "Deliverable Three"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Deliverable Greater Than Three</th>
                                                {!isEmpty(deliverableGreaterThanThree) && deliverableGreaterThanThree.length > 0
                                                    ? deliverableGreaterThanThree.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 7,
                                                            name: "Deliverable Greater Than Three"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Completed Clients</th>
                                                {!isEmpty(completedClients) && completedClients.length > 0
                                                    ? completedClients.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 8,
                                                            name: "Completed Clients"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Dormant Clients</th>
                                                {!isEmpty(dormantClients) && dormantClients.length > 0
                                                    ? dormantClients.map((value, ix) => {
                                                        const productMonth = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].month : ""
                                                        const productYear = !isEmpty(product_data) && product_data.length > 0 ?
                                                            product_data[ix].year : ""
                                                        const monthName = productMonth
                                                        const monthValue = monthName === "January" ? 1 :
                                                            monthName === "February" ? 2 : monthName === "March" ? 3 : monthName === "April" ? 4 : monthName === "May" ? 5 :
                                                                monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "August" ? 8 : monthName === "September" ? 9 :
                                                                    monthName === "October" ? 10 : monthName === "November" ? 11 : monthName === "December" ? 12 :
                                                                        ""
                                                        const payload = {
                                                            month: monthValue,
                                                            year: productYear,
                                                            menuMode: 9,
                                                            name: "Dormant Clients"
                                                        }
                                                        return (
                                                            <td key={ix} onClick={() => handleClickTab(payload)}
                                                                style={{ color: "#e40d8c", fontSize: "14px", textDecoration: "underline", textAlign: "center" }}>{value}</td>
                                                        )
                                                    })
                                                    : []}
                                            </tr>
                                            <tr>
                                                <th>Total</th>
                                                {!isEmpty(columnWiseTotal) && columnWiseTotal.length > 0
                                                    ? columnWiseTotal.map((value, ix) => (
                                                        <th key={ix} style={{ textAlign: "center" }}
                                                        >{value}</th>
                                                    ))
                                                    : []}
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <div className="font-size-14 mt-2">
                                        <p>Showing Rows 1 to 7 of 7</p>
                                    </div>
                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}
        </div>
    )
}
MonthWisePendingClientCount.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
    dateFormat: PropTypes.string
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,MonthWisePendingClientCount
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MonthWisePendingClientCount)
)
